import { Box, Button, Card, CardContent, CardMedia, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";

export const Settings: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid sx={{ backgroundColor: '#f4f4f4', minHeight: '100vh', position: 'relative', pb: '4rem' }}>
      {/* Main Content */}
      <Grid sx={{ padding: '2rem' }}>
        <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" color="green" gutterBottom>
            Settings
          </Typography>
          <IconButton>
            <WSIcons.CloseIcon
              sx={{ backgroundColor: "red", color: "white" }}
              onClick={() => handleClick("/")}
            />
          </IconButton>
        </Grid>

        {/* Grid Layout for Settings Options */}
        <Grid container spacing={2}>
          {/* List of Setting Options */}
          {[
            { icon: <WSIcons.SettingsIcon />, label: 'User Settings' },
            { icon: <WSIcons.ComputerIcon />, label: 'Peripheral' },
            { icon: <WSIcons.TableRestaurantIcon />, label: 'Table Assign' },
            { icon: <WSIcons.LockIcon />, label: 'Transaction Lock' },
            { icon: <WSIcons.LocalPizzaIcon />, label: 'Freeze/Unfreeze Item' },
            { icon: <WSIcons.Person />, label: 'Employee Login/Logout' },
            { icon: <WSIcons.ScreenLockLandscapeIcon />, label: 'Open/Close Shift' },
            { icon: <WSIcons.MessageIcon />, label: 'Change Message' },
            { icon: <WSIcons.GTranslateIcon />, label: 'Refresh Language' },
          ].map((option, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ display: 'flex', alignItems: 'center', backgroundColor: 'white' }}>
                <CardMedia sx={{ padding: '1rem', color: 'green' }}>{option.icon}</CardMedia>
                <CardContent>
                  <Typography variant="body1">{option.label}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Footer */}
      <Grid
        container
        sx={{
          padding: ".5rem",
          alignItems: "center",
          position: "fixed",
          bottom: 0,
          width: "100%",
        }}
      >
        <Grid item>
          <WSIcons.GTranslateIcon/>
        </Grid>

        
      </Grid>
    </Grid>
  );
});
